import React from 'react';
import styled from '@emotion/styled';
import BgImg from 'ui/images/top/topOffer_bg.png';
import BgImg02 from 'ui/images/top/topOffer_img02@2x.png';
import BgImg01 from 'ui/images/top/topOffer_img01@2x.png';
import OfferImg01 from 'ui/images/top/topOffer_img01@2x.png';
import { mqMin } from 'utils/responsive';
import { Only } from 'ui/components/elements/Only/Only';
import { useNavigate } from 'react-router-dom';
import { AgentSignUpRequest } from 'ui/components/company/screens/modals/AgentSignUpRequest/AgentSignUpRequest';
import { useModal } from 'ui/components/screens/modals/useModal';

const Container = styled.div`
    position: relative;
    border-top: solid 2px var(--dark-blue);
    border-bottom: solid 2px var(--dark-blue);
    background-image: url(${BgImg}), url(${BgImg02}), url(${BgImg01});
    background-repeat: repeat, no-repeat, no-repeat;
    background-size:
        10px 10px,
        auto 177px,
        auto 177px;
    background-position:
        left -20px bottom,
        right -18px bottom;
    background-color: #56b6e6;
    color: #fff;
    text-align: center;
    padding: 47px 0;

    ${mqMin('NARROW')} {
        position: relative;
        width: 900px;
        border: 0;
        background: none;
        padding: 0;
        margin: 0 auto 0 auto;
    }
`;

const LeftContainer = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        position: absolute;
        bottom: 0;
        left: -65px;
        display: block;
        width: 172px;
    }
`;

const RightContainer = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        position: absolute;
        bottom: 0;
        right: -55px;
        display: block;
        width: 172px;
    }
`;

const OfferMainContainer = styled.div`
    ${mqMin('NARROW')} {
        width: 100%;
        border: solid 2px var(--dark-blue);
        border-radius: 12px;
        background-image: url(${BgImg});
        background-repeat: repeat;
        background-size: 10px 10px;
        background-color: #56b6e6;
        color: #fff;
        text-align: center;
        padding: 54px 0;
    }
`;

const H2 = styled.h2`
    font-size: 1.5rem; /*24px*/
    line-height: 1.8rem;
    letter-spacing: 0.1em;
    margin-bottom: 10px;
`;

const OfferText = styled.p`
    font-size: min(3.6vw, 16px);
    line-height: 1.8rem;
    letter-spacing: 0.1em;
    margin-bottom: 30px;

    ${mqMin('NARROW')} {
        font-size: 1rem;
    }
`;

const ButtonOrange = styled.a`
    display: block;
    background-color: var(--orange);
    border-radius: 8px;
    border: solid 1px #fff;
    color: #fff;
    text-align: center;
    text-decoration: none;
    padding: 16px 20px;
    margin: 0 auto;
    transition: all 0.3s;
    width: 250px;
    cursor: pointer;

    &:hover {
        background: none;
    }

    &:visited {
        color: #fff;
    }
`;

const ForAgent = styled.div`
    text-align: center;
    padding: 42px 0 62px 0;

    ${mqMin('NARROW')} {
        text-align: center;
        padding: 57px 0 78px 0;
    }
`;

const TopOfferFooterP = styled.p`
    line-height: 1.8rem;
    letter-spacing: 0.1em;

    a {
        color: var(--blue);
        font-size: 1.1875rem;
    }

    ${mqMin('NARROW')} {
        font-size: 1.1875rem; /*19px*/
        line-height: 1.8rem;
        letter-spacing: 0.1em;
        margin-bottom: 19px;
    }
`;

const ButtonBlue = styled.a`
    display: block;
    background-color: var(--blue);
    border-radius: 8px;
    border: solid 1px #fff;
    color: #fff;
    text-align: center;
    text-decoration: none;
    padding: 16px 20px;
    margin: 0 auto 0 auto;
    transition: all 0.3s;
    width: 250px;
    cursor: pointer;

    &:hover {
        color: var(--blue);
        background: none;
    }

    &:visited {
        color: #fff;
    }
`;

export const Offer: React.FC = () => {
    const navigate = useNavigate();
    const preOpenModal = useModal();
    const { openModal, createModal } = preOpenModal;
    const goToRegister = () => {
        if (import.meta.env.PROD) {
            openModal(); //プレオープン時はこちらを有効化
        } else {
            navigate('/send-registration-mail/');
        }
    };
    const goToSellerPage = () => {
        navigate('/');
    };
    const goToContactPage = () => {
        window.open('/contact/', '_blank');
    };
    return (
        <>
            {createModal(<AgentSignUpRequest />)}
            <section className="fadein fadein_y">
                <Container>
                    <LeftContainer>
                        <img src={OfferImg01} alt="" />
                    </LeftContainer>
                    <OfferMainContainer>
                        <H2>わずか1分で登録完了！</H2>
                        <OfferText>
                            マイページ登録すると
                            <Only sp>
                                <br />
                            </Only>
                            さらに詳しい情報を閲覧できます。
                        </OfferText>
                        <ButtonOrange onClick={goToRegister}>無料登録して企業を探す</ButtonOrange>
                    </OfferMainContainer>
                    <RightContainer>
                        <img src={BgImg02} alt="" />
                    </RightContainer>
                </Container>
                <ForAgent>
                    <ButtonBlue onClick={goToContactPage}>お問い合わせはこちら</ButtonBlue>
                    <TopOfferFooterP>
                        <br />
                        <br />
                        M&Aにより譲渡を検討している企業様はこちら
                    </TopOfferFooterP>
                    <ButtonBlue onClick={goToSellerPage}>売り手企業はこちら</ButtonBlue>
                </ForAgent>
            </section>
        </>
    );
};
